<mat-accordion class="example-headers-align" multi>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span mat-line
          >Invoice<mat-icon
            aria-hidden="false"
            aria-label="Example home icon"
            >picture_as_pdf</mat-icon
          ></span
        >
      </mat-panel-title>
    </mat-expansion-panel-header>
    <span class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" (click)="OnImprimir($event,'Invoice')">
      Download
      <mat-icon aria-hidden="false" aria-label="file_download"
        >file_download</mat-icon
      >
    </span>
  </mat-expansion-panel>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span mat-line
          >Packing Slip<mat-icon
            aria-hidden="false"
            aria-label="Example home icon"
            >picture_as_pdf</mat-icon
          ></span
        >
      </mat-panel-title>
    </mat-expansion-panel-header>
    <span class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" (click)="OnImprimir($event,'Packing_Slip')">
      Download
      <mat-icon aria-hidden="false" aria-label="file_download"
        >file_download</mat-icon
      >
    </span>
  </mat-expansion-panel>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span mat-line
          >Pick Ticket<mat-icon
            aria-hidden="false"
            aria-label="Example home icon"
            >picture_as_pdf</mat-icon
          ></span
        >
      </mat-panel-title>
    </mat-expansion-panel-header>
    <span class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" (click)="OnImprimir($event,'Pick_Ticket')">
      Download
      <mat-icon aria-hidden="false" aria-label="file_download"
        >file_download</mat-icon
      >
    </span>
  </mat-expansion-panel>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span mat-line
          >Pick Ticket LOT#<mat-icon
            aria-hidden="false"
            aria-label="Example home icon"
            >picture_as_pdf</mat-icon
          ></span
        >
      </mat-panel-title>
    </mat-expansion-panel-header>
    <span class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" (click)="OnImprimir($event,'Pick_Ticket_LOT')">
      Download
      <mat-icon aria-hidden="false" aria-label="file_download"
        >file_download</mat-icon
      >
    </span>
  </mat-expansion-panel>
</mat-accordion>

